"use strict";

var interpolate = require("sprintf-js");

function BookingPageRenderHelper(deps) {
    var utils = deps.utils;
    var getConfig = deps.config.getConfig;
    var sdk = deps.sdk;

    //DOM nodes
    var rootTarget = deps.rootTarget;
    var bookingPageTarget;
    var tz;

    // functions
    var getAvailability;
    var triggerError;

    // Event handler when a timeslot is clicked in FullCalendar
    var showBookingPage = function (eventData, customerTimezone) {
        utils.doCallback("showBookingPage", getConfig(), eventData);

        tz = customerTimezone;

        var template = require(".././templates/booking-page/booking-page.html");

        var formattedStart = eventData.formattedStart;

        moment.locale(getConfig().fullcalendar.locale);

        var dateFormat = moment.localeData().longDateFormat("L");
        var timeFormat = moment.localeData().longDateFormat("LT");

        var displayTime = formattedStart ? formattedStart : undefined;

        if (!displayTime) {
            displayTime =
                formatTimestamp(eventData.start, timeFormat);
        }
        // var allocatedResource = eventData.resources ? eventData.resources[0].name : false;

        bookingPageTarget = $(
            template.render({
                chosenDate: formattedStart || formatTimestamp(eventData.start, dateFormat),
                chosenTime: displayTime,
                allocatedProductPrefix: getConfig().ui.localization.allocated_product_prefix,
                allocatedResourcePrefix: getConfig().ui.localization.allocated_resource_prefix,
                allocatedProduct: getConfig().selectedProduct.name,
                allocatedResource: eventData.resource_name,
                closeIcon: require("!svg-inline-loader!.././assets/close-icon.svg"),
                checkmarkIcon: require("!svg-inline-loader!.././assets/checkmark-icon.svg"),
                loadingIcon: require("!svg-inline-loader!.././assets/loading-spinner.svg"),
                errorIcon: require("!svg-inline-loader!.././assets/error-icon.svg"),
                submitText: getConfig().ui.localization.submit_button,
                successMessage: interpolate.sprintf(
                    getConfig().ui.localization.success_message,
                    '<span class="booked-email"></span>'
                )
            })
        );

        var formFields = bookingPageTarget.find(".bookingjs-form-fields");
        $(formFields).append(renderCustomerFields());

        var form = bookingPageTarget.children(".bookingjs-form");

        bookingPageTarget.children(".bookingjs-bookpage-close").on("click", function (e) {
            e.preventDefault();
            var bookingHasBeenCreated = $(form).hasClass("success");
            if (bookingHasBeenCreated) getAvailability();
            hideBookingPage();
        });

        if (eventData.resources) {
            utils.logDebug(["Available resources for chosen timeslot:", eventData.resources], config);
        }

        form.find(".bookingjs-form-input").on("input", function () {
            var field = $(this).closest(".bookingjs-form-field");
            if (this.value) field.addClass("bookingjs-form-field--dirty");
            else field.removeClass("bookingjs-form-field--dirty");
        });

        form.on("submit", function (e) {
            submitBookingForm(this, e, eventData);
        });

        $(rootTarget).on("customer-timezone-changed", function () {
            if (!bookingPageTarget) return;
            $(".bookingjs-bookpage-date").text(formatTimestamp(eventData.start, dateFormat));
            $(".bookingjs-bookpage-time").text(
                formatTimestamp(eventData.start, timeFormat) + " - " + formatTimestamp(eventData.end, timeFormat)
            );
        });

        $(document).on("keyup", function (e) {
            // escape key maps to keycode `27`
            if (e.keyCode === 27) {
                hideBookingPage();
            }
        });

        rootTarget.append(bookingPageTarget);

        setTimeout(function () {
            calcBookingPageFormHeight();
            bookingPageTarget.addClass("show");
        }, 100);
    };

    // Remove the booking page DOM node
    var hideBookingPage = function () {
        utils.doCallback("closeBookingPage", getConfig());

        bookingPageTarget.removeClass("show");

        setTimeout(function () {
            bookingPageTarget.remove();
        }, 200);

        $(document).off("keyup");
    };

    // Render customer fields
    var renderCustomerFields = function () {
        var textTemplate = require(".././templates/fields/text.html");
        var textareaTemplate = require(".././templates/fields/textarea.html");
        var selectTemplate = require(".././templates/fields/select.html");
        var checkboxTemplate = require(".././templates/fields/checkbox.html");

        var fieldsTarget = [];
        $.each(getConfig().customer_fields, function (key, field) {
            var tmpl = textTemplate;
            if (field.format === "textarea") tmpl = textareaTemplate;
            if (field.format === "select") tmpl = selectTemplate;
            if (field.format === "checkbox") tmpl = checkboxTemplate;
            if (!field.format) field.format = "text";
            if (key === "email") field.format = "email";
            var data = $.extend( // use Object.assign instead
                {
                    key: key,
                    arrowDownIcon: require("!svg-inline-loader!.././assets/arrow-down-icon.svg")
                },
                field
            );
            var fieldTarget = $(tmpl.render(data));
            fieldsTarget.push(fieldTarget);
        });

        return fieldsTarget;
    };

    var calcBookingPageFormHeight = function () {
        var headerHeight = $(".bookingjs-bookpage-header").outerHeight(true);
        var closeButtonHeight = $(".bookingjs-bookpage-close").outerHeight(true);
        var dialogHeight = $(".bookingjs-bookpage").height();
        var footerHeight = $(".bookingjs-footer").outerHeight(true);
        var buttonHeight = $(".bookingjs-form-button").outerHeight(true);
        var fieldsHeight = $(".bookingjs-form-fields").height();

        $(".bookingjs-form").height(dialogHeight - (headerHeight + footerHeight));

        var formHeight = $(".bookingjs-form").height();

        $(".bookingjs-form-box").height(Math.min(formHeight - buttonHeight, fieldsHeight));
    };

    // Output timestamp into given format in customers timezone
    var formatTimestamp = function (start, format) {
        return moment(start).tz(tz).format(format);
    };

    // Event handler on form submit
    var submitBookingForm = function (form, e, eventData) {
        e.preventDefault();

        var formElement = $(form);

        if (formElement.hasClass("success")) {
            getAvailability();
            hideBookingPage();
            return;
        }

        // Abort if form is submitting, have submitted or does not validate
        if (formElement.hasClass("loading") || formElement.hasClass("error") || !e.target.checkValidity()) {
            var submitButton = formElement.find(".bookingjs-form-button");
            submitButton.addClass("button-shake");
            setTimeout(function () {
                submitButton.removeClass("button-shake");
            }, 500);
            return;
        }

        var formData = {};
        $.each(formElement.serializeArray(), function (i, field) {
            formData[field.name] = field.value;
        });

        formElement.addClass("loading");

        utils.doCallback("submitBookingForm", getConfig(), formData);

        // Call create event endpoint
        timumCreateBooking(formData, eventData)
            .then(function (response) {
                formElement.find(".booked-email").html(formData.email);
                formElement.removeClass("loading").addClass("success");
            })
            .catch(function (response) {
                showBookingFailed(formElement);
            });
    };

    var showBookingFailed = function (formElement) {
        var submitButton = formElement.find(".bookingjs-form-button");
        submitButton.addClass("button-shake");
        setTimeout(function () {
            submitButton.removeClass("button-shake");
        }, 500);

        formElement.removeClass("loading").addClass("error");
        setTimeout(function () {
            formElement.removeClass("error");
        }, 2000);
    };

    var setRootTarget = function (target) {
        rootTarget = target;
    };

    // Create new booking
    var timumCreateBooking = function (formData, eventData) {
        var nativeFields = ["firstName","lastName", "email", "messages", "phone"];

        var chosenProductUuid =
            eventData.kind === "models.LotAppointment"? eventData.product_uuid : getConfig().selectedProduct.uuid;

        var data = {
            start: eventData.start.format(),
            timeslot_uuid: eventData.timeslot_uuid,
            end: eventData.end.format(),
            product_uuid: chosenProductUuid,

            channelId: formData.resource_channel || getConfig().resource_channel,

            firstname: formData.firstName,
            lastname: formData.lastName,
            email: formData.email,
            mobile: formData.mobile,
            locale: getConfig()?.fullcalendar?.locale ?? "de" 
        };

        if (getConfig().customer_fields.message) {
            data.message = formData.message
        }
        if (getConfig().customer_fields.phone) {
            data.phone = formData.phone;
        }

        // Save custom fields in meta object
        $.each(getConfig().customer_fields, function (key, field) {
            if ($.inArray(key, nativeFields) >= 0) return;
            if (field.format === "checkbox") formData[key] = !!formData[key];
            data[key] = formData[key];
            data.description += (getConfig().customer_fields[key].title || key) + ": " + formData[key] + "\n";
        });

        $.extend(true, data, getConfig().booking);// use Object.assign instead

        utils.doCallback("createBookingStarted", getConfig(), data);

        var request = sdk
            .createAppointmentWithConsumer({}, data)
            .then(function (response) {
                utils.doCallback("createBookingSuccessful", getConfig(), response);
            })
            .catch(function (response) {
                utils.doCallback("createBookingFailed", getConfig(), response);
                render.triggerError(["An error with timum Create Booking occured", response]);
            });

        return request;
    };

    var setRequiredFunctions = function (availabilities, error) {
        getAvailability = availabilities;
        triggerError = error;
    };

    return {
        showBookingPage: showBookingPage,
        setRootTarget: setRootTarget,
        setRequiredFunctions: setRequiredFunctions
    };
}

module.exports = BookingPageRenderHelper;
